var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"footer"},[_c('p',[_vm._v(_vm._s(_vm.$t('Contact')))]),_vm._v(" "),_c('div',{staticClass:"contact"},[_c('span',[_vm._v(_vm._s(_vm.$t('Telephone')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('QQ'))+"：3393736529")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Email'))+"：gtn@hundsun.com")])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b046fc4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageFooter.vue
// module id = 480L
// module chunks = 52